(function() {
    // Find the container and get the data attribute
    const productStitchingContainer = document.getElementById('product-stitching-container');
    if (!productStitchingContainer) return;
    const productGroupId = productStitchingContainer.dataset.group;
    const productHandle = productStitchingContainer.dataset.handle;
    let isLoaded = false;
    
    const stitchingConfig = (window.theme && window.theme.product_stitching) || {};
    const apiToken = stitchingConfig.app_token;
    const hideContainers = () => {
        document.querySelectorAll('.product-stitching-container').forEach((container) => {
            container.style.display = 'none';
        });
    };

    // The Storefront API needs a token (Theme settings > Storefront API token).
    // Without one every request is a 401, so skip the call instead of erroring.
    if (productGroupId && !apiToken) {
        hideContainers();
        return;
    }

    if (productGroupId) {
        
        // Create the GraphQL query
        const query = `
            query Swatches($namespace: String = "custom", $key: String = "product_stitching", $value: String = "${productGroupId}") {
              collection(handle: "all") {
                handle
                products(first: 20, 
                  filters: {
                    productMetafield: {
                      namespace: $namespace,
                      key: $key,
                      value: $value
                  }
                }) {
                  edges {
                    node {
                      handle
                      title
                      onlineStoreUrl
                      availableForSale
                      featuredImage {
                        url
                      }
                      variants(first: 20) {
                        edges {
                          node {
                            title
                          }
                        }
                      }
                      metafield: metafield(namespace: $namespace, key: $key){
                        value
                        description
                        type
                      }
                      colour_group: metafield(namespace: "filters", key: "colour_group"){
                        value
                        description
                        type
                      }
                    }
                  }
                }
              }
            }
        `;
        
        fetch(`${stitchingConfig.shop_url}/api/2024-04/graphql.json`, {
            method: "POST",
            headers: {
                'X-Shopify-Storefront-Access-Token': apiToken,
                'Content-Type': 'application/graphql'
            },
            body: query
        })
        .then(response => {
            if (!response.ok) {
                throw new Error(`Storefront API responded ${response.status}`);
            }
            return response.json();
        })
        .then(data => {
            const productStitchingContainerList = document.querySelectorAll('.product-stitching-container');
            const collection = data && data.data && data.data.collection;
            if (!collection) {
                hideContainers();
                return;
            }
            let products = collection.products.edges.map(x => x.node);
            // Safeguard: the metafield filter above is only applied when
            // custom.product_stitching is enabled as a Search & Discovery filter.
            // If it is not, Shopify ignores it and returns unrelated products,
            // so keep only true siblings of this group.
            const normaliseGroup = (v) => String(v || '').trim().toLowerCase();
            const groupKey = normaliseGroup(productGroupId);
            products = products.filter(p => p && p.metafield && normaliseGroup(p.metafield.value) === groupKey);
            let colorSwatchesHTML = '';
            let containerHTML = '';
            let currentColorName = '';
            if (products.length > 1) {
                for (let i = 0; i < products.length; i++) {
                    let product = products[i];
                    let currentClass = (product.handle === productHandle) ? ' is-selected' : '';
                    if (!product.availableForSale) {
                        currentClass += ' is-sold-out';
                    }
                    let variantNames = product.variants.edges.map(x => x.node);
                    if (currentColorName === '' && product.handle === productHandle) {
                        currentColorName = variantNames[0].title.split(' / ')[0] || '';
                    }
                    const swatchLink = product.onlineStoreUrl ?? 'javascript:void(0)';
                    const colourGroupValue = product.colour_group && product.colour_group.value ? product.colour_group.value.toLowerCase().replace(/\s+/g, '-') : '';
                    if (colourGroupValue === '') {
                        colorSwatchesHTML += `<a href="${swatchLink}" class="o-swatches__swatch-option ${currentClass}">
                            <figure class="image-lazy o-swatches__swatch-option-image image-lazy--contain"><img
                                loading="lazy" src="${product.featuredImage.url}" alt="${product.title}" width="28" height="28"/></figure>
                        </a>`;
                    } else {
                        const isSoldOut = !product.availableForSale;
                        const soldOutIcon = isSoldOut 
                            ? '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 192 192" style="width: 20px; height: 20px; display: block;"><path d="M150 42 42 150M150 150 42 42" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="8" fill="none"/></svg>'
                            : '';
                        const checkIcon = (product.handle === productHandle && !isSoldOut)
                            ? '<span class="icon icon-check"></span>'
                            : '';
                        
                        colorSwatchesHTML += `<a href="${swatchLink}" class="swatches swatch__button swatch__button--rectangle o-swatches__swatch-option s-swatch--${colourGroupValue} s-pdp-swatch--${colourGroupValue} ${currentClass}">
                          <span class="swatch__label" data-swatch="${colourGroupValue}" data-tooltip="${colourGroupValue}" style="--swatch: var(--${colourGroupValue});">
                            ${isSoldOut ? `<span class="o-swatches__swatch-option--soldout">${soldOutIcon}</span>` : ''}
                            <span class="visually-hidden">${colourGroupValue}</span>
                            ${checkIcon}
                          </span>
                        </a>`;
                    }                    
                }
                
                if (colorSwatchesHTML !== '') {
                    containerHTML = `<div class="selector-wrapper selector-wrapper--boxes selector-wrapper--swatches o-swatches is-color">
                      <fieldset class="radio__fieldset radio__fieldset--rectangle">
                        <div class="radio__legend">
                            <div class="radio__legend__label label-typography">                  
                              <span class="o-swatches__swatch-header-name">Colour:</span>
                              <span class="o-swatches__swatch-header-value">${currentColorName}</span>
                            </div>
                        </div>
                        <div class="radio__buttons">${colorSwatchesHTML}</div>
                      </fieldset>
                    </div>`;
                }
                if (productStitchingContainerList.length  && !isLoaded) {
                    Array.from(productStitchingContainerList).forEach((productStitchingContainer) => {
                        productStitchingContainer.innerHTML = containerHTML;
                    });
                    isLoaded = true;
                }
            } else {
                productStitchingContainerList.forEach((productStitchingContainer) => {
                    productStitchingContainer.style.display = 'none';
                });
            }
        })
        .catch(error => {
            hideContainers();
            console.warn('[product-stitching] could not load sibling products:', error.message || error);
        });
    }
})();
